<template>
    <div class="d-flex align-center line-height-1">
        <div class="mr-1">{{ reporte.comision | currency(reporte.divisa_code) }} <template v-if="reporte.percent_comision">~ {{ reporte.percent_comision | percent }}</template></div>
        <template v-if="(reporte.comparison?.venta && reporte.comparison?.comision) && (reporte.comparison.venta[0] != reporte.comparison.comision[0])">
            <div class="d-flex text-caption" :class="{
                'error--text': reporte.comparison.comision[0] > reporte.comparison.venta[0],
                'accent--text': reporte.comparison.comision[0] < reporte.comparison.venta[0],
            }">
                <div class="ml-1">{{ reporte.comparison.comision[0] | percent }}</div>
                <v-icon :color="reporte.comparison.comision[0] > reporte.comparison.venta[0] ? 'error' : 'accent'" small>
                    <template v-if="reporte.comparison.comision[1] > 0">mdi-trending-up</template>
                    <template v-else>mdi-trending-down</template>
                </v-icon>
            </div>
        </template>
    </div>
</template>
<script>

export default {
    props: {
        reporte: {
            required: true
        }
    }
}
</script>